"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mannWhitneyTestTwoSamplePValue = exports.tTestTwoSamplePValue = void 0;
const arsham_1 = require("./arsham");
const simple_statistics_1 = require("./simple-statistics");
const mannwhitneyu_1 = require("@common/tsutils/statistics/mannwhitneyu");
// R-Alternative
// t.test(
//     x           = c(1, 2, 3, 4),
//     y           = c(3, 4, 5, 6),
//     alternative ="two.sided",
//     mu          =0,
//     var.equal   =TRUE,
//     conf.level  =0.95
// )
// W = 2, p-value = 0.1081
/**
 * T-Student p-value
 * @param x First array of values
 * @param y Second array of values
 * @param mu The difference
 * @return number The p-value
 */
function tTestTwoSamplePValue(x, y, mu = 0) {
    const value = (0, simple_statistics_1.tTestTwoSample)(x, y, mu);
    const dg = x.length + y.length - 2;
    return (0, arsham_1.StudT)(value, dg);
}
exports.tTestTwoSamplePValue = tTestTwoSamplePValue;
// R-Alternative
// wilcox.test(
//     x           = c(1, 2, 3, 4),
//     y           = c(3, 4, 5, 6),
//     alternative ="two.sided",
//     mu          =0,
//     var.equal   =TRUE,
//     conf.level  =0.95
// )
// W = 2, p-value = 0.1081
/**
 * Mann Whitney U Test (Wilcoxon Rank-Sum Test)
 * @param x First array of values
 * @param y Second array of values
 * @return number The p-value
 */
function mannWhitneyTestTwoSamplePValue(x, y) {
    return (0, mannwhitneyu_1.mannWhitneyUTest)(x, y).p;
}
exports.mannWhitneyTestTwoSamplePValue = mannWhitneyTestTwoSamplePValue;
